'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _uuid = require('uuid');

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Store = function () {
  function Store() {
    _classCallCheck(this, Store);

    this.subs = [];
  }

  _createClass(Store, [{
    key: 'sub',
    value: function sub(fn) {
      var id = (0, _uuid.v4)();
      this.subs = [].concat(_toConsumableArray(this.subs), [{
        id: id,
        fn: fn
      }]);
      return this.unsub.bind(this, id);
    }
  }, {
    key: 'unsub',
    value: function unsub(id) {
      this.subs = [].concat(_toConsumableArray(this.subs)).filter(function (sub) {
        return sub.id !== id;
      });
    }
  }, {
    key: 'pub',
    value: function pub(data) {
      this.subs.forEach(function (_ref) {
        var fn = _ref.fn;
        return fn(data);
      });
    }
  }]);

  return Store;
}();

var stores = {};

exports.default = function (store) {
  if (stores[store] === undefined) stores[store] = new Store();
  return stores[store];
};